import R from 'ramda'

const TIMESTAMP_DISPLAY_TYPE = 'Send at specific time'
const TIMESTAMP_TRIGGER_TYPE = 'TIMESTAMP'

const isTimestampFormTrigger = R.propEq('type', TIMESTAMP_DISPLAY_TYPE)

const getData = R.propOr(new Date().valueOf(), 'data')

const getExpiration = R.pipe(
  R.applySpec({
    expiration: R.propOr(60, 'expiration'),
    data: R.propOr(new Date().valueOf(), 'data')
  }),
  R.evolve({
    expiration: R.pipe(Number, R.multiply(60000)),
    data: Number
  }),
  R.converge(R.add, [R.prop('expiration'), R.prop('data')])
)

const convertTimestampFormTriggerToWidgetTrigger = R.applySpec({
  type: R.always(TIMESTAMP_TRIGGER_TYPE),
  data: getData,
  expiration: getExpiration,
  executedAt: R.prop('executedAt'),
  operator: R.always('AND'),
  primary: R.T
})

export { isTimestampFormTrigger, convertTimestampFormTriggerToWidgetTrigger }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/triggers/common-triggers/form-to-widget/timestamp.js